/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { skillsListFeedback } from "../funcs/skillsListFeedback.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListSkillFeedbackRequest,
  ListSkillFeedbackResponse,
  ListSkillFeedbackSecurity,
} from "../models/operations/listskillfeedback.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type SkillFeedbackQueryData = ListSkillFeedbackResponse;

export type SkillFeedbackInfiniteQueryData = PageIterator<
  ListSkillFeedbackResponse,
  { cursor: string }
>;

export type SkillFeedbackPageParams = PageIterator<
  ListSkillFeedbackResponse,
  { cursor: string }
>["~next"];

export function prefetchSkillFeedback(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListSkillFeedbackRequest,
  security?: ListSkillFeedbackSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSkillFeedbackQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchSkillFeedbackInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListSkillFeedbackRequest,
  security?: ListSkillFeedbackSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildSkillFeedbackInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as SkillFeedbackPageParams,
    getNextPageParam: (previousPage: SkillFeedbackInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildSkillFeedbackQuery(
  client$: GramCore,
  request: ListSkillFeedbackRequest,
  security?: ListSkillFeedbackSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<SkillFeedbackQueryData>;
} {
  return {
    queryKey: queryKeySkillFeedback({
      id: request.id,
      cursor: request.cursor,
      limit: request.limit,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function skillFeedbackQueryFn(
      ctx,
    ): Promise<SkillFeedbackQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(skillsListFeedback(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildSkillFeedbackInfiniteQuery(
  client$: GramCore,
  request: ListSkillFeedbackRequest,
  security?: ListSkillFeedbackSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, SkillFeedbackPageParams>,
  ) => Promise<SkillFeedbackInfiniteQueryData>;
} {
  return {
    queryKey: queryKeySkillFeedbackInfinite({
      id: request.id,
      cursor: request.cursor,
      limit: request.limit,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function skillFeedbackQuery(
      ctx,
    ): Promise<SkillFeedbackInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(skillsListFeedback(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(skillsListFeedback(
        client$,
        {
          ...request,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeySkillFeedback(
  parameters: {
    id: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "listFeedback", parameters];
}

export function queryKeySkillFeedbackInfinite(
  parameters: {
    id: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "listFeedback", "infinite", parameters];
}
